import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Box, Typography } from "@mui/material";
import PointBox from '../components/PointBox';
import ReadyStart from '../screens/ReadyStart';
import SubscriptionsView from '../screens/Subscriptions';
import PointSolidSheet from '../components/PointSolidSheet';
import SheetPoint from '../components/SheetPoint';

import DollarIcon from "../assets/icons/dollar-icon.svg";
import TimeRollIcon from "../assets/icons/time-roll.svg";
import CancelIcon from "../assets/icons/cancel-icon.svg";
import MoneyStartIcon from '../assets/icons/money-start.svg';
import BoltSparkIcon from '../assets/icons/bolt-spark.svg';
import LongQueueIcon from '../assets/icons/long-queue.svg';
import MapIcon from '../assets/icons/map-icon.svg';
import Step from "../components/Step";
import BoltIcon from "../assets/icons/bolt-spark.svg";


function Driver() {
  return (
    <>
      {/* HEADER HERE */}
      <NavBar />

      {/* HERO SECTION */}
      <Box sx={{
        display: "flex",
        flexDirection: 'column',
        justifyContent: "space-between",
        gap: "2rem",
        width: "100%",
        background: 'linear-gradient(264.22deg, #181A18 -124.15%, #0C0D0C 52.54%, #181A18 200.05%)',
        paddingTop: { xs: '5rem', sm: "8rem" },
        height: '100vh',
        maxHeight: { xs: '100%', md: '150vw' },
      }}>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            justifyContent: 'space-between',
            textAlign: { md: "left" },
            gap: "3.5rem",
            padding: { xs: '3rem', sm: '4rem', md: '6.4rem', lg: '6.4rem' },
          }}
        >

          <Typography
            sx={{
              color: "toughGrey",
              fontSize: '1.6rem',
              fontWeight: 500,
              width: 'fit-content',
            }}
          >
            DRIVERS
          </Typography>


          <Typography
            sx={{
              color: "white",
              fontSize: { xs: '4rem', sm: '5rem', md: '7.2rem' },
              fontWeight: 700,
              lineHeight: { xs: '4rem', sm: '5rem', md: '6rem' },
              maxWidth: '20ch',
            }}
          >
            Charge when you want, where you want.
          </Typography>
        </Box>

        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: '100%',
            maxHeight: 'calc(60vh - 5rem)',
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              right: 0,
              left: 0,
              zIndex: 0,
              opacity: 1,
              backgroundImage: `url(${require('../assets/images/driver-bg-image.png')})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'top',
              backgroundOrigin: 'top',

            }}
          ></Box>
        </Box>

      </Box>

      {/* DRIVERS PAGE CONTENT HERE */}
      <Box sx={{
        padding: "6.4rem",
        px: { xs: '2rem', sm: '2rem', md: '6.4rem', lg: '6.4rem' },
        background: 'linear-gradient(264.22deg, #181A18 -124.15%, #0C0D0C 52.54%, #181A18 200.05%)',
      }}>
        {/* CHALLENGE SECTION */}
        <Box
          sx={{
            display: "flex",
            overflow: "hidden",
            my: { xs: '5rem', md: '18rem' },
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: "100%",
          }}>

          <Box
            sx={{
              alignItems: 'center',
              justifyContent: 'center', textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: '3.6rem', sm: '4.2rem', md: '4.6rem' },
                fontWeight: 700,
                my: { xs: '2rem', sm: '5rem' },
                m: 'auto',
                lineHeight: '4.5rem',
                width: { xs: '90%', md: '100%' }
              }}
            >
              Public charging is ridden with problems.
            </Typography>
          </Box>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(25rem, 1fr))",
              gap: "5rem",
              justifyContent: "start",
              my: "4rem",
            }}
          >
            <Box component="li">
              <PointBox
                image={MoneyStartIcon}
                title="High costs"
                text='The national average cost at public fast chargers is $0.60 per kWh, making it 
              significantly more expensive than home or private charging options'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={LongQueueIcon}
                title="Long wait times"
                text='Finding an available charger can take up to 30 minutes or more in high-demand areas, adding time to every trip.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={BoltSparkIcon}
                title="Unpredictability"
                text='Public stations are frequently occupied, broken, or subject to surge pricing.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={MapIcon}
                title="Inconvenient locations"
                text='Charging stops require out-of-the-way detours, wasting valuable time'>
              </PointBox>
            </Box>
          </Box>
        </Box >

        {/* SOLUTION SECTION */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: "7rem", sm: "10rem" },
          justifyItems: "space-around",
          width: "100%",
          maxWidth: "128rem",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: "3.2rem",
              mt: { xs: '0rem', md: '4rem' }
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '3.4rem', sm: '4.8rem' },
                fontWeight: 700,
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '20ch',
                textAlign: { xs: 'left' }
              }}
            >
              SplitEV provides a solution.
            </Typography>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }} >
              <Typography
                component="h2"
                sx={{
                  color: "primary.main",
                  fontSize: { xs: "1.8rem", sm: '2.4rem' },
                  fontWeight: 800,
                  mb: "0rem"
                }}
              >
                40% cheaper than public charging
              </Typography>

              <Box sx={{ listStyle: "disc", color: "paleWhite", ml: "1.8rem" }} component="ol">
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                  Save up to $1,920/year on charging costs compared to public charging.
                </Box>
              </Box>

            </Box>


            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Typography
                component="h2"
                sx={{
                  color: "primary.main",
                  fontSize: { xs: "1.8rem", sm: '2.4rem' },
                  fontWeight: 800,
                }}
              >
                No wait times, no unreliable stations
              </Typography>

              <Box
                sx={{
                  listStyle: "disc",
                  color: "paleWhite",
                  ml: "1.8rem",
                  display: "flex",
                  flexDirection: "column",
                  gap: "1.4rem"
                }}
                component="ol">
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                  Reserve a charger in advance through the SplitEV app to guarantee availability.
                </Box>

                <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                  Charge overnight or between shifts to ensure vehicles are always ready.
                </Box>

                <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                  No more detours—SplitEV chargers are located where you already work, live, and travel.
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            data-aos="flip-down"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            sx={{
              position: "relative",
              width: { sm: "40rem", md: "65rem" },
              height: { xs: "40rem", sm: "65rem" },
              borderRadius: "2.5rem",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${require('../assets/images/driver-focus-on-charging.jpg')})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top',
                backgroundOrigin: 'top',
              }}
            ></Box>
          </Box>
        </Box>

        {/* SPLITEV VS PUBLIC SECTION */}
        <Box
          sx={{
            display: "flex",
            overflow: "hidden",
            m: "auto",
            my: { xs: '5rem', md: '18rem' },
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: "100%",
            maxWidth: "115rem",
          }}>

          <Box
            sx={{
              alignItems: 'center',
              justifyContent: 'center', textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: '3.6rem', sm: '4.2rem', md: '4.8rem' },
                fontWeight: 700,
                my: { xs: '2rem', sm: '2.4rem' },
                m: 'auto',
                lineHeight: '4.5rem',
                width: { xs: '90%', md: '100%' },
                mb: { xs: "1rem", md: "4rem" }
              }}
            >
              SplitEV’s Network vs. Public Charging
            </Typography>
          </Box>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(25rem, 1fr))",
              gap: "5rem",
              justifyContent: "start",
              my: "4rem",
            }}
          >
            <Box component="li">
              <PointSolidSheet
                image={BoltIcon}
                title="SplitEV"
              >
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    margin: "auto",
                    gap: "5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box component="li">
                    <SheetPoint
                      image={DollarIcon}
                      title="Starts at $59"
                      text='Flat-rate subscription with predictable pricing'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={TimeRollIcon}
                      title="No waiting time"
                      text='Reserve a charger in advance, charge where you live and work.'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={MapIcon}
                      title="Available 24/7"
                      text='Thousands of private, dedicated chargers integrated into communities'>
                    </SheetPoint>
                  </Box>

                </Box>
              </PointSolidSheet>
            </Box>

            <Box component="li">
              <PointSolidSheet
                image={MapIcon}
                title="Public Charging"
              >
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    margin: "auto",
                    gap: "5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box component="li">
                    <SheetPoint
                      image={CancelIcon}
                      title="$150-250+ per month"
                      text='Variable rates, often up to $0.60/kWh or more.'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={CancelIcon}
                      title="10+ hours waiting per month"
                      text='First-come, first-served, leading to long waits.'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={CancelIcon}
                      title="Unpredictable availability"
                      text='Limited number of high-traffic public stations.'>
                    </SheetPoint>
                  </Box>
                </Box>
              </PointSolidSheet>
            </Box>
          </Box>
        </Box>

        {/* NETWORK INFO SECTION */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: "7rem", sm: "10rem" },
          justifyItems: "space-around",
          width: "100%",
          maxWidth: "128rem",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>

          <Box
            data-aos="flip-down"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            sx={{
              position: "relative",
              width: { sm: "40rem", md: "65rem" },
              height: { xs: "40rem", sm: "65rem" },
              borderRadius: "2.5rem",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${require('../assets/images/charging-ev-4.svg').default})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top',
                backgroundOrigin: 'top',
              }}
            ></Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: "3.2rem",
              mt: { xs: '0rem', md: '4rem' }
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '3.4rem', sm: '4.6rem' },
                fontWeight: 700,
                lineHeight: { xs: '4rem', sm: '5.7rem' },
                maxWidth: '25ch',
                textAlign: { xs: 'left' }
              }}
            >
              Access a nationwide charging network.
            </Typography>

            <Typography
              sx={{
                color: "paleWhite",
                fontSize: '1.8rem',
                fontWeight: 400,
                lineHeight: { xs: '2.5rem', sm: '2.7rem' },
                textAlign: { xs: 'left' },
                maxWidth: "65ch"
              }}
            >
              SplitEV partners with homeowners, businesses, and private property owners
              to provide a more extensive, accessible,
              and cost-effective charging solution than traditional public infrastructure.
            </Typography>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Typography
                component="h2"
                sx={{
                  color: "primary.main",
                  fontSize: { xs: "1.8rem", sm: '2.4rem' },
                  fontWeight: 800,
                }}
              >
                Home-Based Charging
              </Typography>

              <Box sx={{ listStyle: "none", color: "paleWhite" }} component="ol">
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                  Secure overnight charging at residential stations.
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Typography
                component="h2"
                sx={{
                  color: "primary.main",
                  fontSize: { xs: "1.8rem", sm: '2.4rem' },
                  fontWeight: 800,
                  mb: "0rem"
                }}
              >
                Workplace and Commercial Sites
              </Typography>

              <Box sx={{
                listStyle: "none", color: "paleWhite"
              }} component="ol">
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                  Charge during the workday without downtime.
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Typography
                component="h2"
                sx={{
                  color: "primary.main",
                  fontSize: { xs: "1.8rem", sm: '2.4rem' },
                  fontWeight: 800,
                  mb: "0rem"
                }}
              >
                Fleet Integration
              </Typography>

              <Box sx={{ listStyle: "none", color: "paleWhite" }} component="ol">
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                  Optimize charging routes with a reliable network.
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* HOW IT WORKS SECTION */}
        <Box sx={{
          my: { xs: '5rem', md: '18rem' },
        }}>

          <Typography
            sx={{
              color: "white",
              fontWeight: 700,
              margin: "4rem auto",
              fontSize: { xs: '3.4rem', sm: '4.6rem' },
              lineHeight: { xs: '4rem', sm: '5.7rem' },
              textAlign: "center"
            }}
          >
            How it Works
          </Typography>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              my: "4rem auto",
              maxWidth: "55ch",
              width: "95%",
              display: "flex",
              flexDirection: "column",
              gap: "2rem"
            }}
          >
            <Step
              position="1"
              title="Download the App"
              text=" Get the SplitEV app on your phone. It’s your gateway to a seamless 
              charging experience across North America."
            />

            <Step
              position="2"
              title="Subscribe to a Plan"
              text="Pick the subscription level (Basic or Premium) that suits your driving needs. 
              No haggling or hidden charges—just straightforward pricing."
            />

            <Step
              position="3"
              title="Locate & Charge"
              text="Open the app to find the nearest SplitEV station and plug in. 
              Enjoy the reliability of an expanding nationwide network fueled by your fellow EV enthusiasts."
            />
          </Box>

        </Box>

        {/* SUBSCRIPTION SECTION */}
        <Box sx={{
          my: { xs: '5rem', md: '7rem' },
        }}>
          {/* <SubscriptionsView></SubscriptionsView> */}
        </Box>
      </Box >

      {/* FOOTER SECTION */}
      <ReadyStart phrase="Sign up now and experience hassle-free, affordable EV charging"></ReadyStart>
      < Footer />
    </>
  );
}

export default Driver;